import type { SignatureExport } from '../ui/signaturePad'
import type { FormTemplate } from '../template/types'

/**
 * The form currently being filled in, held in memory across the prepare, read
 * and sign screens.
 *
 * In memory on purpose, matching `Draft.kt`. A half-finished release holds a
 * name, an address and a signature, and there is no reason for that to be
 * written to disk if the tab is closed before it is completed.
 */

export interface DraftState {
  template: FormTemplate | null
  values: Record<string, string>
  signatures: Record<string, SignatureExport>
  readToEnd: boolean
}

export const draft: DraftState = {
  template: null,
  values: {},
  signatures: {},
  readToEnd: false,
}

export function startDraft(template: FormTemplate, initial: Record<string, string>): void {
  draft.template = template
  draft.values = { ...initial }
  draft.signatures = {}
  draft.readToEnd = false
}

export function clearDraft(): void {
  draft.template = null
  draft.values = {}
  draft.signatures = {}
  draft.readToEnd = false
}

export function signerName(): string {
  if (!draft.template) return ''
  return (draft.values[draft.template.nameFieldKey] ?? '').trim()
}

export function signerEmail(): string {
  if (!draft.template?.emailFieldKey) return ''
  return (draft.values[draft.template.emailFieldKey] ?? '').trim()
}

/** Required signatures with nothing captured yet. */
export function missingSignatures(): string[] {
  if (!draft.template) return []
  return draft.template.signatures
    .filter((s) => s.required && !draft.signatures[s.key])
    .map((s) => s.label)
}
